/*
Testna okruženja:
beta2.bigbang.si (vezana na PIM11 PROD, novi design)
sdhr.bigbangmarkerdev.info (HR; vezano na PIM11 TEST, nov design)
mp.bigbangmarkerdev.info (SI; vezano na PIM11 TEST, nov design)

beta.bigbang.si (vezana na PIM11 PROD, star design)
pim11.bigbangmarkerdev.info (vezano na PIM11 TEST, star design)
pa.bigbangmarkerdev.info (vezano na PIM11 TEST)
*/

export const config = {
	default: 'prod',
	prod: {
		host: 'https://www.bigbang.si',
		lang: 'si',
		apiCache: true,
		routeCacheExpire: 305, // 5 min
	},
	mp: {
		host: 'https://mp.bigbangmarkerdev.info',
		lang: 'si',
		apiCache: false,
		routeCacheExpire: 0, // 5 min
	},
	sdhr: {
		host: 'https://sdhr.bigbangmarkerdev.info',
		lang: 'hr',
		apiCache: false,
		routeCacheExpire: 305, // 5 min
	},
	beta2: {
		host: 'https://beta2.bigbang.si',
		lang: 'si',
		apiCache: false,
		routeCacheExpire: 0, // 5 min
	},
	pim11: {
		host: 'https://pim11.bigbangmarkerdev.info',
		lang: 'si',
		apiCache: false,
		routeCacheExpire: 0, // 5 min
	},	
};